export default __webpack_public_path__ + "static/media/techm.041c9f8a.jpg";